import React from 'react';
import IconWrapper from '../IconWrapper';
const EmailIcon = (props) => {
    const brand = process.env.BRAND || process.env.BRAND_PREFIX;
    switch (brand) {
        case 'cos':
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("g", { fill: "none", fillRule: "evenodd" },
                    React.createElement("path", { fill: "#FFF", d: "M0 0h24v24H0z" }),
                    React.createElement("path", { d: "M0 0h24v24H0z" }),
                    React.createElement("g", { stroke: "#1B1B1B", strokeWidth: ".8" },
                        React.createElement("path", { d: "M2.65 5.9h19.783v12.579H2.65z" }),
                        React.createElement("path", { d: "m12.542 7.154 9.437 11.325H3.104l9.438-11.325Z" }),
                        React.createElement("path", { d: "M12.542 15.226 21.868 5.9H3.216l9.326 9.326Z", fill: "#FFF" })))));
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "M22,0 C23.1045695,0 24,0.8954305 24,2 L24,18 C24,19.1045695 23.1045695,20 22,20 L2,20 C0.8954305,20 0,19.1045695 0,18 L0,2 C0,0.8954305 0.8954305,0 2,0 L22,0 Z M23,3.486 L12.2973018,11.4020095 C12.1206994,11.5326139 11.8795412,11.5326683 11.7028798,11.4021438 L1,3.494 L1,18 C1,18.5522847 1.44771525,19 2,19 L22,19 C22.5522847,19 23,18.5522847 23,18 L23,3.486 Z M22,1 L2,1 C1.44771525,1 1,1.44771525 1,2 L1,2.251 L11.9998596,10.378228 L23,2.242 L23,2 C23,1.44771525 22.5522847,1 22,1 Z" })));
    }
};
export default EmailIcon;
//# sourceMappingURL=EmailIcon.js.map